// extracted by mini-css-extract-plugin
module.exports = {"slim":"events-heading-module--slim--2_kT2","wide":"events-heading-module--wide--1WqsB"};